export enum TenantRoutes {
    TenantCreate = 'create',
    TenantList = ''
}
